import * as serialActions from './actions';
import * as serialActionTypes from './types';
import serialReducer from './reducers';

const { SERIAL_INIT_STATE } = serialActionTypes;

export { serialActions, serialActionTypes, serialReducer, SERIAL_INIT_STATE };
